export enum Step {
  CreateAccount = 'create-account-form',
  EnterEmail = 'email-form',
  ForgotPassword = 'forgot-password-form',
  ResetPassword = 'reset-password-form',
  SignIn = 'password-form'
}
